import {
  TRADE_APPLICATION_SUBMISSION,
  TRADE_OPTIONS,
} from '@src/quince-components/src/molecules/tradeApplicationForm/constants'
import { initializeImg } from '@src/telemetry/integrations/provider-utils/initialize-img'
import { initializeScript } from '@src/telemetry/integrations/provider-utils/initialize-script'
import { TelemetryIntegration } from '@src/telemetry/telemetry-events.types'

import { TELEMETRY_DOMAINS } from '../telemetry-domains.constants'
import { TELEMETRY_EVENT_NAMES } from '../telemetry-events.constants'

export const LinkedInPixel: TelemetryIntegration = {
  config: {
    enabled: true,
    eventIdealTimeout: 1000,
    domain: TELEMETRY_DOMAINS.LINKEDIN_PIXEL,
  },

  initialize: async () => {
    window._linkedin_partner_id = '1873316'
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids ?? []
    window._linkedin_data_partner_ids.push(window._linkedin_partner_id)

    if (window.lintrk) return
    window.lintrk = function (a, b) {
      if (window.lintrk) (window.lintrk.q = window.lintrk.q ?? []).push([a, b])
    }
    window.lintrk.q = []

    await initializeScript({
      key: 'linkedin-insight',
      domain: TELEMETRY_DOMAINS.LINKEDIN_PIXEL,
      path: '/li.lms-analytics/insight.min.js',
      injectAt: 'beforeFirstScript',
    })

    initializeImg({
      id: 'linkedin_pixel_img',
      src: `https://px.ads.linkedin.com/collect/?pid=${window._linkedin_partner_id}&fmt=gif`,
      attributes: { style: 'display:none;' },
    })
  },

  events: {
    [TELEMETRY_EVENT_NAMES.FORM_SUBMIT]: properties => {
      const isTradeApplicationSubmit = properties.action === TRADE_APPLICATION_SUBMISSION
      const isTradeOptionGifting = properties.context.applicationType === TRADE_OPTIONS.Gifting
      if (isTradeApplicationSubmit && isTradeOptionGifting) {
        trackLinkedInGiftingConversion()
      }
    },
  },
}

export const trackLinkedInGiftingConversion = () => {
  if (window.lintrk) window.lintrk('track', { conversion_id: 15887476 })
}
